
            const data = {"name":"close2","data":{"width":"16","height":"16","viewBox":"0 0 16 16","data":"<path pid=\"0\" d=\"M12.243 4.51a.5.5 0 0 0-.707-.707L8 7.338 4.465 3.803a.5.5 0 0 0-.707.707l3.535 3.535-3.535 3.536a.5.5 0 1 0 .707.707L8 8.752l3.536 3.536a.5.5 0 0 0 .707-.707L8.708 8.045l3.535-3.535Z\" _fill=\"#81889B\"/>","originalColors":[{"type":"fill","color":"#81889B"}],"stopColors":[]}}
        
                    module.exports = data
                    